import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, switchMap, take } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Store } from '@ngrx/store';
import { NGXLogger } from 'ngx-logger';
import { clearUserData } from 'app/state/actions/auth.actions';
import { selectCurrentUserId } from 'app/state/selectors/auth.selectors';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const messageService = inject(MessageService);
  const logger = inject(NGXLogger);  

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      logger.error('HTTP Error', {
        url: req.url,
        method: req.method,
        status: error.status,
        message: error.message,
        error: error.error
      });
      if (error.status >= 400 || error.status === 0) {
        const message = error?.error?.message || 'An error occurred';
        const finalMessage = "HttpError[" + error.status.toString() + "]: " + message;
        messageService.add({
          severity: 'error',
          summary: 'Http Error',
          detail: finalMessage,
          life: 7000,
          sticky: false,
        });
      }
      if (error.status === 401 &&
          error.statusText === 'Unauthorized' &&
          (error.error.message.includes('auth/session-cookie-revoked') ||
           error.error.message.includes('auth/user-not-found') ||
           error.error.message.includes('auth/id-token-expired') ||
           error.error.message.includes('cookie \'__session\' required'))) {
        return store.select(selectCurrentUserId).pipe(
          take(1),
          switchMap(currentUserId => {
            if (currentUserId !== null) {
              store.dispatch(clearUserData());
            }
            return throwError(() => error);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
